// extracted by mini-css-extract-plugin
module.exports = {"content":"App_content__1Wt3K","main":"App_main__uN9ca"};